import { Component, Input } from '@angular/core';
import { ProductMenuFooterComponent } from '../product-menu-footer.component';
import { FilterUtils } from '../../../../../../../../utils/filter-utils';

@Component({
  selector: 'app-plantlife-non-smokable-footer',
  templateUrl: './plantlife-non-smokable-footer.component.html',
  styleUrls: ['./plantlife-non-smokable-footer.component.scss'],
  standalone: false
})
export class PlantlifeNonSmokableFooterComponent extends ProductMenuFooterComponent {
  @Input() includeClassifications: boolean = false;
  @Input() includeBadges: boolean = true;
  @Input() hideSides: boolean = false;
  @Input() removeBottomPadding: boolean = false;
  protected readonly FilterUtils = FilterUtils;
}
